window.$crisp = [];
window.CRISP_WEBSITE_ID = location.host.match(/pinme\.to/)
	? '772fb6fd-7a22-4870-984b-a1c180aa66d0'
	: '5794fb3a-801e-4c03-a0c9-9b47e418f21e';
(function () {
	'use strict';
	var s = document.createElement('script');
	s.src = 'https://client.crisp.chat/l.js';
	s.async = 1;
	document.getElementsByTagName('head')[0].appendChild(s);
})();
